import { request } from '@/utils/request';

export interface DictData {
  dictLabel: string;
  dictValue: string;
  dictSort?: number;
  dictType?: string;
  remark?: string;
}

/** 根据字典类型查询字典数据 */
export function getDictData(dictType: string) {
  return request<{ code: number; msg: string; data: DictData[] }>(`/system/dict/data/type/${dictType}`);
}

/** 关注产品 */
export function getProductTypeDict() {
  return getDictData('sys_website_product');
}

/** 咨询类型 */
export function getMessageTypeDict() {
  return getDictData('sys_message_type');
}
